import React, { useEffect, useState } from "react";
import api from "../../services/axiosInstance";
import { FaCalendarAlt, FaClock } from "react-icons/fa";
import { Link } from "react-router-dom";

const UpcomingCoursesDelete = () => {
const [courses, setCourses] = useState([]);
const [deletingId, setDeletingId] = useState(null);

  useEffect(() => {
    api
      .get("/timeline/upcoming")
      .then((res) => setCourses(res.data))
      .catch((err) => console.error(err));
  }, []);

  const handleDeleteTimeline = async (courseId) => {
  const confirmDelete = window.confirm(
    "Remove this course from the timeline?"
  );
  if (!confirmDelete) return;

  try {
    setDeletingId(courseId);
    await api.delete(`/timeline/course/${courseId}`);

    // remove from UI instantly
    setCourses((prev) =>
      prev.filter((c) => c.course_id !== courseId)
    );
  } catch (err) {
    console.error("Delete timeline error:", err);
  } finally {
    setDeletingId(null);
  }
};


  if (courses.length === 0) {
    return (
      <div className="max-w-6xl mx-auto mt-10 text-center text-gray-500 py-12">
        No upcoming courses.
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto mt-12 px-4">
      {/* Timeline */}
      <div className="relative">

        {/* Horizontal Line */}
        <div className="absolute top-1/2 left-0 w-full h-0.5 bg-gradient-to-r from-green-100 via-green-300 to-green-100 transform -translate-y-1/2" />

        <div className="flex justify-between items-center relative z-10">

          {courses.map((course) => (
            <div
              key={course.course_id}
              className="flex flex-col items-center w-1/4 min-w-[220px]"
            >
              {/* Card */}
              <div className="bg-white border border-green-100 rounded-xl p-5 mb-4 shadow-md hover:shadow-lg transition-shadow duration-300 text-center w-full max-w-xs">
                <h2 className="text-sm font-semibold text-gray-900 mb-2 line-clamp-2 h-10">
                  {course.name}
                </h2>
                <div className="space-y-2 mb-4">
                  <div className="flex items-center justify-center gap-2 text-gray-600 text-xs">
                    <FaCalendarAlt className="text-green-500" />
                    <span>
                      {new Date(course.start_date).toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric'
                      })}
                    </span>
                  </div>

                  {course.duration && (
                    <div className="flex items-center justify-center gap-2 text-gray-600 text-xs">
                      <FaClock className="text-green-500" />
                      <span>{course.duration} weeks</span>
                    </div>
                  )}
                </div>

                <Link
                  to={`/courses/${course.course_id}`}
                  className="inline-flex items-center text-green-600 hover:text-green-700 text-xs font-semibold transition-colors duration-200"
                >
                  View Details
                  <span className="ml-1">→</span>
                </Link>

                <button
  onClick={() => handleDeleteTimeline(course.course_id)}
  disabled={deletingId === course.course_id}
  className="mt-3 text-xs font-semibold text-red-500 hover:text-red-600 transition-colors"
>
  {deletingId === course.course_id ? "Removing..." : "Remove from timeline"}
</button>

              </div>

              {/* Dot with shadow and animation */}
              <div className="relative">
                <div className="w-5 h-5 bg-white rounded-full border-4 border-green-500 shadow-md hover:scale-110 transition-transform duration-200" />
                <div className="absolute inset-0 w-5 h-5 bg-green-400 rounded-full animate-ping opacity-20" />
              </div>

              {/* Date Label */}
              <span className="mt-3 text-xs font-medium text-gray-600">
                {new Date(course.start_date).toLocaleDateString('en-US', {
                  weekday: 'short',
                  month: 'short',
                  day: 'numeric'
                })}
              </span>
            </div>
          ))}

        </div>
      </div>
    </div>
  );
};

export default UpcomingCoursesDelete;